const module = {
  config: {
    name: "export-data",
    svg: "../static/img/icon/menu/export.svg",
    desc: "Berisi modul untuk export database",
    layout: true
  },
  routes: [
    // list-sarpras-monitoring
    {
      name: "Monitoring Sarpras",
      icon: "ri-record-circle-line",
      path: "/list-sarpras-monitoring",
      component: () => import("./sarpras/list-sarpras-monitoring.vue"),
      separator: "Sarpras"
    },
    // list-maintenance-harvest_plant
    {
      name: "Pemeliharaan Penaburan Penanaman",
      icon: "ri-record-circle-line",
      path: "/list-maintenance-harvest_plant",
      component: () => import("./maintenance/list-maintenance-harvest_plant.vue"),
      separator: "Pemeliharaan"
    },
    {
      name: "Pemeliharaan BBST",
      icon: "ri-record-circle-line",
      path: "/list-maintenance-bbst",
      component: () => import("./maintenance/list-maintenance-bbst.vue"),
      separator: "Pemeliharaan"
    },
    {
      name: "Pemeliharaan BST",
      icon: "ri-record-circle-line",
      path: "/list-maintenance-bst",
      component: () => import("./maintenance/list-maintenance-bst.vue"),
      separator: "Pemeliharaan"
    },
    // detail_bst
    {
      name: "Fase Sebelumnya",
      icon: "ri-record-circle-line",
      path: "/list-source-bst",
      component: () => import("./bst/list-source-bst.vue"),
      separator: "Asal BST"
    },
    // inisiasi_bst
    {
      name: "Inisiasi",
      icon: "ri-record-circle-line",
      path: "/list-inisiasi-bst",
      component: () => import("./bst/list-inisiasi-bst.vue"),
      separator: "Asal BST"
    },
    // detail_bst_po
    {
      name: "Pengadaan Bibit",
      icon: "ri-record-circle-line",
      path: "/list-po-bst",
      component: () => import("./bst/list-po-bst.vue"),
      separator: "Asal BST"
    },
    // monitoring_bst
    {
      name: "Audit Bibit",
      icon: "ri-record-circle-line",
      path: "/list-audit-bst",
      component: () => import("./bst/list-audit-bst.vue"),
      separator: "Asal BST"
    },
    // issue_bst
    {
      name: "Monitoring Masalah",
      icon: "ri-record-circle-line",
      path: "/list-issue-bst",
      component: () => import("./bst/list-issue-bst.vue"),
      separator: "Asal BST"
    },
    // distributions
    {
      name: "Daftar Penilikan Lubang",
      icon: "ri-record-circle-line",
      path: "/distribution-list-distributions",
      component: () => import("./geko/list-distributions.vue"),
      separator: "GEKO"
    },
    // detail_allocation_seeds
    {
      name: "Daftar Alokasi Bibit",
      icon: "ri-record-circle-line",
      path: "/distribution-allocation-seeds",
      component: () => import("./distribution/list-allocation-seeds.vue"),
      separator: "Distribusi"
    },
    // detail_labels
    {
      name: "Daftar Label",
      icon: "ri-record-circle-line",
      path: "/distribution-list-labels",
      component: () => import("./distribution/list-labels.vue"),
      separator: "Distribusi"
    },
    // distribution-export
    {
      name: "Export Distribusi",
      icon: "ri-record-circle-line",
      path: "/distribution-export",
      component: () => import("./distribution/distribution-export.vue"),
      separator: "Distribusi"
    },
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/export-db/_index.js